export const resolveLinkTarget = (link?: string) => {
  if (link?.match(/([\w\s\.\:\/-]+\.[pP][dD][fF])/g)) {
    return '_blank'
  }
  return link?.charAt(0) !== '/' && link?.charAt(0) !== '#' ? '_blank' : ''
}
